import { createContext, useContext, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { API } from "../config";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(() => {
    const saved = sessionStorage.getItem("ukok-admin");
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState(() => sessionStorage.getItem("ukok-token") || null);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setAdmin(res.data.admin);
    setToken(res.data.token);
    sessionStorage.setItem("ukok-admin", JSON.stringify(res.data.admin));
    sessionStorage.setItem("ukok-token", res.data.token);
    return res.data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const res = await axios.post(`${API}/auth/register`, { email, password, name });
    setAdmin(res.data.admin);
    setToken(res.data.token);
    sessionStorage.setItem("ukok-admin", JSON.stringify(res.data.admin));
    sessionStorage.setItem("ukok-token", res.data.token);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    setAdmin(null);
    setToken(null);
    sessionStorage.removeItem("ukok-admin");
    sessionStorage.removeItem("ukok-token");
  }, []);

  const authAxios = useMemo(() => {
    const instance = axios.create({ baseURL: API });
    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
    return instance;
  }, [token]);

  const value = useMemo(() => ({
    admin, token, login, register, logout, authAxios
  }), [admin, token, login, register, logout, authAxios]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
